<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-10 15:16:45
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 11:42:57
-->
<template>
  <div class="innovative intracardiac">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require(`@/assets/images/pc/innovate${language == 'en' ? '/en' : ''}/heart_bj.png`)" alt="" srcset="">
      <div v-if="language != 'en'" class="innovative-bj-txt" @click="$router.push({ path: language == 'en' ? '/en/guidance' :'/guidance' })"></div>
    </div>
    <div class="innovative-process innovative-wrap-item">
      <div class="innovative-container">
        <img @contextmenu="($event) => {$event.returnValue = false; return false}" @dragstart.prevent class="innovative-process-img" :src="$t('product.heart.processImg')" alt="" srcset="">
      </div>
    </div>
    <div class="innovative-intelligence p-0 innovative-wrap-item posrel">
      <img class="wid100" :src="$t('product.heart.intelligence.img')" alt="" srcset="">
      <div class="flex innovative-container posabs hei100 t-0 align_items_center p-t-30 p-b-30 textj" >
        <div class="flex_2">
          <div class="innovative-wrap-item-title nowrap p-b-10" v-html="$t('product.heart.intelligence.title')"></div>
          <div class="innovative-intelligence-des">{{$t('product.heart.intelligence.des')}}</div>
        </div>
        <div class="flex_3 flex align_items_center justify_content_end" style="background: red;">
        </div>
      </div>
    </div>
    <div class="innovative-advantages innovative-wrap-item" :class="language == 'en' ? 'p-t-70 p-b-76' : 'p-t-160 p-b-106'">
      <div class="innovative-container">
        <div :class="['innovative-advantages-title innovative-wrap-item-title textc', language == 'zh' ? '' : 'p-b-0 fz-30']">{{$t('product.heart.coreAdvantages.title')}}</div>
        <template v-if="language == 'zh'">
          <el-row :gutter="clientWidth > 1680 ? 130 : 60" class="innovative-advantages-box clearfix flex textj">
            <el-col :span="8" class="flex" v-for="item, index in $t('product.heart.coreAdvantages.list')" :key="index">
              <div class="innovative-advantages-item wid100 zh flex flex_col" >
                <div :class="['textc innovative-advantages-item-img flex flex_col align_items_center']">
                  <img class="" :src="item.img" alt="" srcset="">
                  <div class="innovative-advantages-item-title p-0 p-t-20">{{item.title}}</div>
                </div>
                <div class="innovative-advantages-item-des flex_1">
                  <p class="des-text" v-for="$item, $index in item.des" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <div class="flex innovative-advantages-box en justify_content_center">
            <div>
              <div v-for="item, index in $t('product.heart.coreAdvantages.list')" :key="index">
                <div class="innovative-advantages-item wid100 flex en" >
                  <div :class="['textc innovative-advantages-item-img flex flex_col align_items_center', 'p-r-120']">
                    <img class="" :src="item.img" alt="" srcset="">
                    <div class="innovative-advantages-item-title p-t-10">{{item.title}}</div>
                  </div>
                  <div class="flex_1">
                    <p v-for="$item, $index in item.des" :key="$index" v-html="$item"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="innovative-products innovative-wrap-item">
      <div class="innovative-container">
        <div class="innovative-products-title p-b-40 innovative-wrap-item-title textc">{{$t('product.heart.relatedProducts.title')}}</div>
        <el-row :gutter="15" class="">
          <el-col :span="6" class="" v-for="item, index in $t('product.heart.relatedProducts.list')" :key="index">
            <div class="innovative-products-item cursor_pointer" @click="$router.push({ path: item.path })">
              <img class="wid100" :src="item.img" alt="" srcset="">
              <el-tooltip popper-class="tooltip-item" effect="dark" placement="bottom-end" :offset="6" :disabled="index == 0 ? tooltipOne1 : index == 1 ? tooltipOne2 : index == 2 ? tooltipOne3 : tooltipOne4">
                <div slot="content" v-html="item.title"></div>
                <div class="innovative-products-item-title ellipsis" v-html="item.title" @mouseenter="projectMouseenter($event, `tooltipOne${index + 1 }`)" @mouseleave="projectMouseleave()"></div>
              </el-tooltip>
              <i class="t">&nbsp;</i>
              <i class="r">&nbsp;</i>
              <i class="b">&nbsp;</i>
              <i class="l">&nbsp;</i>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="innovative-intelligence innovative-wrap-item">
      <div class="flex innovative-container">
        <div class="innovative-intelligence-left innovative-intelligence-text textj" :class="{en: language == 'en'}">
          <div class="innovative-intelligence-title innovative-wrap-item-title nowrap p-b-10" v-html="$t('product.heart.structureFunction.title')"></div>
          <div class="p-t-20 p-r-60">{{$t('product.heart.structureFunction.des')}}</div>
        </div>
        <div class="innovative-intelligence-right flex align_items_center justify_content_end">
          <div class="ilblk posrel">
            <img class="innovative-intelligence-img" :src="$t('product.heart.structureFunction.img')" alt="" srcset="">
            <img class="innovative-intelligence-rotate" :src="$t('product.heart.structureFunction.bjImg')" alt="" srcset="">
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-structureFunction innovative-common-wrap">
      <div class="innovative-common-main">
        <div class="innovative-container flex">
          <div class="flex_3">
            <div class="p-r-90 ">
              <div class="posrel">
                <img class="innovative-structureFunction-rotate" :class="{en: language == 'en'}" :src="$t('product.heart.structureFunction.summary.bjImg')" alt="" srcset="">
                <img class="wid100 posrel" :src="$t('product.heart.structureFunction.summary.img')" alt="" srcset="">
              </div>
            </div>
          </div>
          <div class="flex_1">
            <div class="">
              <div class="fontw p-b-15" v-if="language == 'en'">{{$t('product.heart.structureFunction.products.title')}}</div>
              <div class="posrel">
                <div :class="['m-b-20 innovative-products-item overhid', item.disabled ? 'disabled' : 'cursor_pointer']" v-for="item, index in $t('product.heart.structureFunction.products.list')" :key="index" @click="item.disabled ? '' : $router.push({ path: item.path })">
                  <div class="innovative-products-mask flex justify_content_center align_items_center" v-if="item.disabled"><span class="txt">敬请期待</span></div>
                  <img :style="{width: index == 1 ? 'calc(100% + 10px)' : '100%'}" :src="item.img" alt="" srcset="">
                  <el-tooltip popper-class="tooltip-item" effect="dark" placement="bottom-end" :offset="6" :disabled="index == 0 ? tooltipTwo1 : tooltipTwo2">
                    <div slot="content" v-html="item.title"></div>
                    <div class="innovative-products-item-title ellipsis" v-html="item.title" @mouseenter="projectMouseenter($event, `tooltipTwo${index + 1 }`)" @mouseleave="projectMouseleave()"></div>
                  </el-tooltip>
                  <i class="t">&nbsp;</i>
                  <i class="r">&nbsp;</i>
                  <i class="b">&nbsp;</i>
                  <i class="l">&nbsp;</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <img class="wid100" :src="$t('product.heart.significance.img')" alt="" srcset="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      box1: true,
      box2: true,
      tooltipOne1: true,
      tooltipOne2: true,
      tooltipOne3: true,
      tooltipOne4: true,
      tooltipTwo1: true,
      tooltipTwo2: true
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  },
  methods: {
    projectMouseenter (ev, name) {
      this[name] = ev.target.clientWidth >= ev.target.scrollWidth
    },
    projectMouseleave () {
      this.tooltipOne1 = true
      this.tooltipOne2 = true
      this.tooltipOne3 = true
      this.tooltipOne4 = true
      this.tooltipTwo1 = true
      this.tooltipTwo2 = true
    }
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
@import "~@/styles/animate.less";
.el-tooltip__popper.tooltip-item.is-dark {
  background: rgba(0, 0, 0, 0.6);
  transform: translate3d(-14PX, -14PX, 0);
  &[x-placement^=bottom-end] .popper__arrow{
    border-top-color: rgba(0, 0, 0, 0.6);
    right: 10PX;
    left: auto !important;
    &::after {
      border-top-color: rgba(0, 0, 0, 0);
    }
  }
}
.pc {
  .en {
    .innovative.intracardiac {
      .innovative-advantages .innovative-advantages-item {
        padding: 55PX 0;
        .innovative-advantages-item-img {
          width: 204PX;
          margin-right: 0;
          img {
            margin-top: 10PX;
            transform: scale(1.1);
            margin-bottom: 10PX;
          }
        }
        &.en {
          // padding: 40PX 0;
        }
      }
    }
  }
  .innovative.intracardiac {
    .innovative-intelligence {
      background: linear-gradient(108deg, #19A8EB 0%, #468CD1 100%);
      .innovative-intelligence-des {
        padding-top: 20PX;
      }
      .innovative-intelligence-text {
        padding-top: 100PX;
        &.en {
          padding-top: 60PX;
        }
      }
      .innovative-intelligence-img {
        max-width: 100%;
        position: relative;
        z-index: 2;
      }
      .innovative-intelligence-rotate {
        width: 100%;
        position: absolute;
        top: -6%;
        left: -5%;
        animation: refresh-rotate infinite 5s linear;
      }
      .innovative-intelligence-left, .innovative-intelligence-right {
        width: 50%;
      }
    }
    .innovative-advantages {
      .innovative-advantages-box {
        padding-top: 90PX;
        &.en {
          padding-top: 30PX;
        }
      }
      .innovative-advantages-item {
        padding: 0;
        &.zh {
          background: #FFFFFF;
          box-shadow: 0PX 4PX 12PX 4PX rgba(81,170,255,0.1);
          border-radius: 9PX;
          margin: 0 65PX;
          overflow: hidden;
          .innovative-advantages-item-img {
            padding: 96PX 0 50PX 0;
            margin-right: 0;
            img {
            }
          }
          .innovative-advantages-item-des {
            background: #00A0E9;
            padding: 10PX 15PX;
            color: #ffffff;
            height: 160PX;
            white-space: normal;
            .des-text {
              position: relative;
              padding-left: 16PX;
              &::before {
                content: '';
                position: absolute;
                width: 6PX;
                height: 6PX;
                background: #FFFFFF;
                border-radius: 50%;
                opacity: 0.65;
                left: 0;
                top: 12PX;
              }
            }
          }
        }
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .innovative-products {
      padding: 35PX 0 110PX 0;
    }
    .innovative-structureFunction {
      padding-top: 121PX;
      padding-bottom: 70PX;
      .innovative-structureFunction-rotate {
        width: 49%;
        position: absolute;
        top: 2%;
        left: 0;
        bottom: 0;
        right: 3%;
        overflow: auto;
        margin: auto;
        animation: refresh-rotate 10s linear infinite;
        &.en {
          right: 4.5%;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1400PX) {
  .pc .innovative.intracardiac {
    .innovative-advantages {
      .innovative-advantages-item {
        font-size: 16PX;
        white-space: nowrap;
      }
    }
  }
}
@media screen and (max-width: 1400PX) {
  .pc .innovative.intracardiac {
    .innovative-intelligence {
      .innovative-intelligence-text {
        padding-top: 60PX;
      }
    }
  }
}
@media screen and (max-width: 1366PX) {
  .pc .innovative.intracardiac {
    .innovative-intelligence {
      .innovative-intelligence-left {
        width: 60%;
      }
      .innovative-intelligence-right {
        width: 40%;
      }
    }
    .innovative-structureFunction {
      padding-top: 120PX;
      padding-bottom: 0;
    }
  }
}

@media screen and (max-height: 768PX) {
  .pc .innovative.intracardiac {
    .innovative-advantages {
      padding-bottom: 30PX;
      .innovative-advantages-box {
        padding-top: 30PX;
      }
    }
  }
}
</style>
